<template>
    <div class="gastouder-hours-open">
        <div class="row mb-3 py-2 toolbar-bg">
            <div class="col mb-1 mb-md-0">
                <div class="btn-group btn-group-toggle" role="group">
                    <input
                        class="btn-check"
                        type="radio"
                        name="optionsHourOpen"
                        id="optionsHourOpenPeriod"
                        value="optionsHourOpenPeriod"
                        autocomplete="off"
                        v-model="selectedOption"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="optionsHourOpenPeriod"
                    >Per periode</label>
                    <input
                        class="btn-check"
                        type="radio"
                        name="optionsHourOpen"
                        id="optionsHourOpenChild"
                        value="optionsHourOpenChild"
                        autocomplete="off"
                        v-model="selectedOption"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="optionsHourOpenChild"
                    >Per kind</label>
                </div>
            </div>
        </div>
        <div v-if="selectedOption === 'optionsHourOpenPeriod'">
            <div
                class="accordion mb-1"
                id="accordionHoursOpenPeriod1"
            >
                <div
                    v-bind:key="period"
                    v-for="period in this.childrenPerPeriod"
                    class="accordion-item"
                >
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            :data-bs-target="'#collapseHoursOpenPeriod' + period.period.id"
                            aria-expanded="false"
                            :aria-controls="'collapseHoursOpenPeriod' + period.period.id"
                        >
                            Periode {{ period.period.startDate }} t/m {{ period.period.endDate }}
                            <span class="badge rounded-pill text-bg-secondary ms-auto">{{ period.children.length }}</span>
                        </button>
                    </h2>
                    <div
                        class="accordion-collapse collapse"
                        :id="'collapseHoursOpenPeriod' + period.period.id"
                    >
                        <div class="accordion-body">
                            <div class="list-group list-group-flush">
                                <router-link
                                    class="list-group-item list-group-item-action"
                                    v-bind:key="child"
                                    v-for="child in period.children"
                                    :to="'/gastouder/hours-open/insert/' + period.period.id + '/' + child.id"
                                >
                                    {{ child.name }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="this.childrenPerPeriod.length === 0">
                <div class="alert alert-info">
                    Er zijn geen openstaande uren.
                </div>
            </div>
        </div>
        <div v-if="selectedOption === 'optionsHourOpenChild'">
            <div
                class="accordion mb-1"
                id="accordionHoursOpenChild1"
            >
                <div
                    class="accordion-item"
                    v-bind:key="childPeriod"
                    v-for="childPeriod in this.periodsPerChild"
                >
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            :data-bs-target="'#collapseHoursOpenChild' + childPeriod.child.id"
                            aria-expanded="false"
                            :aria-controls="'collapseHoursOpenChild' + childPeriod.child.id"
                        >
                            {{ childPeriod.child.name }}
                            <span class="badge rounded-pill text-bg-secondary ms-auto">{{ childPeriod.periods.length }}</span>
                        </button>
                    </h2>
                    <div
                        class="accordion-collapse collapse"
                        :id="'collapseHoursOpenChild' + childPeriod.child.id"
                    >
                        <div class="accordion-body">
                            <div class="list-group list-group-flush">
                                <router-link
                                    class="list-group-item list-group-item-action"
                                    v-bind:key="period"
                                    v-for="period in childPeriod.periods"
                                    :to="'/gastouder/hours-open/insert/' + period.id + '/' + childPeriod.child.id"
                                >
                                    Periode {{ period.startDate }} t/m {{ period.endDate }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="this.periodsPerChild.length === 0">
                    <div class="alert alert-info">
                        Er zijn geen openstaande uren.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectedOption: 'optionsHourOpenPeriod',
            childrenPerPeriod: [],
            periodsPerChild: []
        }
    },
    created() {
        this.getChildrenPerPeriod();
        this.getPeriodsPerChild();
    },
    methods: {
        getChildrenPerPeriod() {
            this.$request.post('/gastouder-time-registration/children-per-period')
            .then((response) => {
                this.childrenPerPeriod = response
            });
        },
        getPeriodsPerChild() {
            this.$request.post('/gastouder-time-registration/periods-per-child')
                .then((response) => {
                    this.periodsPerChild = response
                });
        }
    }
}

</script>

<style scoped>
.toolbar-bg {
    background-color: rgba(0,0,0,.025);
    border-top: 1px solid rgba(0,0,0,.1);
    border-bottom: 1px solid rgba(0,0,0,.1);
}

.btn-group-toggle label {
    margin: 0;
}
.btn-group-toggle .btn-outline-secondary {
    background-color: #fff;
    border-color: rgba(0,0,0,.2);
    color: rgba(0,0,0,.5);

    &:hover {
        background-color: rgba(0,0,0,.01);
    }
}
.btn-group-toggle .btn-check:checked + .btn {
    color: hsl(206, 90%, 20%);
    background-color: hsl(206, 68%, 90%);
    border-color: hsl(206, 86%, 73%);
    box-shadow: none;
}

.accordion-button {
    --bs-accordion-btn-padding-y: .75rem;
}
.accordion-button:not(.collapsed) {
    color: #082F4D;
    background-color: #f2f9ff;
    box-shadow: none;
}
.accordion-button:has(.badge.rounded-pill)::after {
    margin-left: 1rem;
}
.accordion-body {
    padding: .5rem;
}

</style>